export default {
  data() {
    return {
      AllFieldDataBill: {
        viewInNote: "Hiển thị trên sổ",
        saleMethods: "Hình thức bán hàng",
        paymentMethod: "Hình thức thanh toán",
        warehouseReceipt: "Kiêm phiếu xuất kho",
        lapKemHoaDon: "Lập kèm hóa đơn",
        daLapHoaDon: "Đã lập hóa đơn",
        ngayHachToan: "Ngày hạch toán (*)",
        ngayChungTu: "Ngày chứng từ(*)",
        soChungTu: "Số chứng từ (*)",
        soPhieuXuat: "Số phiếu xuất",
        lyDoXuat: "Lý do xuất",
        mauSoHĐ: "Mẫu số HĐ",
        kyHieuHĐ: "Ký hiệu hợp đồng",
        soHoaDon: "Số hóa đơn",
        ngayHoaDon: "Ngày hóa đơn",
        maKhachHang: "Mã khách hàng",
        tenKhachHang: "Tên khách hàng",
        diaChi: "Địa chỉ",
        maSoThue: "Mã số thuế",
        dienGiai: "Diễn giải",
        nopVaoTK: "Nộp vào TK",
        nhanVienBanHang: "NV Bán hàng",
        loaiTien: "Loại tiền",
        tyGia: "Tỷ giá",
        maHang: "Mã hàng(*)",
        tenHang: "Tên hàng",
        hangKhuyenMai: "Hàng khuyến mại",
        TKTienChiPhiNo: "TK Tiền/Chi phí/Nợ",
        TKDoanhThuCo: "TK Doanh thu/Có(*)",
        ĐVT: "ĐVT",
        soLuong: "Số lượng",
        donGiaSauThue: "Đơn giá sau thuế",
        donGia: "Đơn giá",
        thanhTien: "Thành tiền",
        thanhTienQuyDoi: "Thành tiền quy đổi",
        tyLeChietKhau: "Tỷ lệ CK(%)",
        tienChietKhau: "Tiền chiết khấu",
        tienChietKhauQuyDoi: "Tiền chiết khấu quy đổi",
        TKChietKhau: "Tk chiết khấu",
        giaTinhThueXK: "Giá tính thuế XK",
        phanTramthueXK: "% thuế XK",
        tienThueXK: "Tiền thuế XK",
        TKThueXK: "TK thuế XK",
        phanTramThueGTGT: "% thuế GTGT",
        tienThueGTGT: "Tiền thuế GTGT",
        tienThueGTGTQuyDoi: "Tiền thuế GTGT quy đổi",
        TKThueGTGT: "TK thuế GTGT",
        HHKhongTHTrenToKhaiThue: "HH không TH trên tờ khai thuế",
        kho: "Kho",
        TKGiaVon: "TK giá vốn",
        TKKho: "TK kho",
        donGiaVon: "Đơn giá vốn",
        tienVon: "Tiền vốn",
        hangHoaGiuHoBanHo: "Hàng hóa giữ hộ/bán hộ"
      },
      AllFieldDataCashReceipts: {
        hienThiTrenSo: "Hiển thị trên sổ",
        ngayHachToan: "Ngày hạch toán (*)",
        ngayChungTu: "Ngày chứng từ (*)",
        soChungTu: "Sổ chứng từ (*)",
        maDoiTuong: "Mã đối tượng",
        tenDoiTuong: "Tên đối tượng",
        diaChi: "Địa chỉ",
        nopVaoTK: "Nộp vào TK",
        moTaiNH: "Mở tại NH",
        lyDoThu: "Lý do thu",
        dienGiaiLyDoThu: "Diễn giải lý do thu",
        nhanVienThu: "Nhân viên thu",
        loaiTien: "Loại tiền",
        tyGia: "Tỷ giá",
        dienGiai: "Diễn giải",
        TKNo: "TK Nợ (*)",
        TKCo: "TK Có (*)",
        soTien: "Số tiền",
        soTienQuyDoi: "Số tiền quy đổi",
        doiTuong:"Đối tượng",
        khoanMucCP: "Khoản mục CP",
        donVi: "Đơn vị",
        doiTuongTHCP: "Đối tượng THCP",
        congTrinh: "Công trình",
        donDatHang: "Đơn đặt hàng",
        hopDongMua: "Hợp đồng mua",
        hopDongBan: "Hợp đồng bán",
        maThongKe: "Mã thống kê"
      },
      AllFieldDataBankReceipts: {
        hienThiTrenSo: "Hiển thị trên sổ",
        ngayHachToan: "Ngày hạch toán (*)",
        ngayChungTu: "Ngày chứng từ (*)",
        soChungTu: "Sổ chứng từ (*)",
        maDoiTuong: "Mã đối tượng",
        tenDoiTuong: "Tên đối tượng",
        diaChi: "Địa chỉ",
        lyDoNop: "Lý do nộp",
        dienGiaiLyDoNop: "Diễn giải lý do nộp",
        nguoiNop: "Người nộp",
        nhanVienThu: "Nhân viên thu",
        kemTheo: "Kèm theo",
        loaiTien: "Loại tiền",
        tyGia: "Tỷ giá",
        dienGiai: "Diễn giải",
        TKNo: "TK Nợ (*)",
        TKCo: "TK Có (*)",
        soTien: "Số tiền",
        quyDoi: "Quy đổi",
        doiTuong:"Đối tượng",
        TKNganHang: "Tài khoản NH"
      }
    };
  }
};
